export default __webpack_public_path__ + "static/bg-4-d2a114e67954735fb181b0d551efa4c5.png";